import ReactPDF, {Text, View} from '@react-pdf/renderer';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React from 'react';

interface CustomTextDTO {
  type?: 'regular' | 'field' | 'paragraph' | 'bold' | 'semibold' | 'montant';
  children?: React.ReactNode;
  style?: ReactPDF.Styles;
}
const CustomText = ({type = 'regular', children, style}: CustomTextDTO) => {
  switch (type) {
    case 'regular':
      return <Text style={[{marginVertical: 1}, style || {}]}>{children}</Text>;
    case 'field':
      return (
        <Text
          style={[
            {
              color: '#595959',
              fontFamily: 'Roboto',
              flexDirection: 'row',
              textOverflow: 'ellipsis',
            },
            style || {},
          ]}>
          {children}
        </Text>
      );
    case 'paragraph':
      return (
        <Text
          style={[
            {
              color: '#595959',
              marginTop: 2,
              marginBottom: 3,
              fontFamily: 'Roboto',
              flexDirection: 'row',
              textOverflow: 'ellipsis',
            },
            style || {},
          ]}>
          {children}
        </Text>
      );
    case 'bold':
      return (
        <Text
          style={[
            {
              color: 'black',
              marginVertical: 1,
              fontFamily: 'Roboto',
              fontWeight: 'bold',
            },
            style || {},
          ]}>
          {children}
        </Text>
      );
    case 'semibold':
      return (
        <Text
          style={[
            {color: '#595959', fontFamily: 'Roboto', fontWeight: 'bold'},
            style || {},
          ]}>
          {children}
        </Text>
      );
    case 'montant':
      return (
        <Text
          style={[
            {
              marginVertical: 1,
              fontFamily: 'Roboto',
              fontWeight: 250,
              textAlign: 'right',
            },
            style || {},
          ]}>
          {children}
        </Text>
      );

    default:
      return (
        <Text
          style={[
            {marginVertical: 1, fontFamily: 'Roboto', fontWeight: 250},
            style || {},
          ]}>
          {children}
        </Text>
      );
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AssurranceVoyage = (props: any) => {
  const {detailContrat} = props;

  return (
    <View style={{paddingRight: 50, fontSize: 10}}>
      <View
        style={{
          marginTop: 140,
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: 80,
        }}>
        <View style={{width: 250}}>
          <CustomText type="field">
            <CustomText type="semibold" children={'AVENANT N° '} />
            <CustomText children={detailContrat.avenantNo} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={"NOM DE 'ASSURE : "} />
            <CustomText children={detailContrat.nomPrenomAssure} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={'N° Compte : '} />
            <CustomText children={detailContrat.noCompte} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={'BRANCHE : '} />
            <CustomText children={detailContrat.branche} />
          </CustomText>
        </View>
        <View style={{width: 210}}>
          <CustomText type="field">
            <CustomText type="semibold" children={'AGENCE : '} />
            <CustomText children={detailContrat.agence} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={'Code : '} />
            <CustomText children={detailContrat.code} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={'Effet Police : '} />
            <CustomText children={detailContrat.effetPolice} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={'Echéance Police : '} />
            <CustomText children={detailContrat.echeancePolice} />
          </CustomText>
          <CustomText type="field">
            <CustomText type="semibold" children={'Expiration Avenant : '} />
            <CustomText children={detailContrat.expirationAvenant} />
          </CustomText>
        </View>
      </View>
      <View style={{height: 180}}>
        <CustomText type="paragraph">Entre les soussignés</CustomText>
        <CustomText type="paragraph">
          <CustomText type="bold">La compagnie d’Assurances ARO</CustomText>
          <CustomText>, dont le Siège Social est sis à </CustomText>
          <CustomText type="bold">Antsahavola Antananarivo</CustomText>
          <CustomText> d’une part</CustomText>
        </CustomText>
        <CustomText type="paragraph">Et</CustomText>
        <CustomText type="paragraph">
          <CustomText type="bold">
            {detailContrat.nomPrenomAssure.toUpperCase()}
          </CustomText>
          <CustomText> demeurant à </CustomText>
          <CustomText type="bold">{`${
            /^lot/.test(detailContrat.adresseSouscripteur) ? '' : 'LOT'
          } ${detailContrat.adresseSouscripteur}`}</CustomText>
          <CustomText> d’autre part,</CustomText>
        </CustomText>
        <CustomText type="paragraph">Il a été convenu ce qui suit :</CustomText>
        <CustomText type="paragraph">
          <CustomText>{`Le contrat d’assurance souscrit par ${detailContrat.nomPrenomSouscripteur} le `}</CustomText>
          <CustomText type="bold">{detailContrat.dateCreation}</CustomText>
          <CustomText> sous le N° </CustomText>
          <CustomText type="bold">{detailContrat.numeroPolice}</CustomText>
          <CustomText> est d'un commun accord résilié à partir du </CustomText>
          <CustomText type="bold">{dayjs().format('DD/MM/YYYY')}</CustomText>
          <CustomText> au motif de : </CustomText>
          <CustomText type="bold">{detailContrat.motif}</CustomText>
        </CustomText>
        <CustomText type="paragraph">
          <CustomText>
            Par conséquent, il sera ristourné au Souscripteur à la signature du
            présent avenant la somme de{' '}
          </CustomText>
          <CustomText type="bold">{`-${detailContrat.primeTTC} Ariary`}</CustomText>
          <CustomText>{` ainsi obtenue :`}</CustomText>
        </CustomText>
      </View>
      <View
        style={{
          flexDirection: 'row',
          fontSize: 10,
          justifyContent: 'space-between',
          height: 120,
        }}>
        <View style={{width: 250}}></View>
        <View style={{width: 210}}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 0,
              marginBottom: 1,
            }}>
            <CustomText style={{style: {flexGrow: 1}}}>
              Prime nette totale{' '}
            </CustomText>
            <CustomText>{`-${detailContrat.primeNette} Ar`}</CustomText>
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 2,
              marginBottom: 1,
            }}>
            <CustomText style={{style: {flexGrow: 1}}}>Accessoires </CustomText>
            <CustomText>{`-${detailContrat.accessoire} Ar`}</CustomText>
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 2,
              marginBottom: 1,
            }}>
            <CustomText style={{style: {flexGrow: 1}}}>T.E </CustomText>
            <CustomText>{`-${detailContrat.primeTE} Ar`}</CustomText>
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 2,
              marginBottom: 1,
            }}>
            <CustomText style={{style: {flexGrow: 1}}}>T.V.A. </CustomText>
            <CustomText>{`-${detailContrat.primeTVA} Ar`}</CustomText>
          </View>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 2,
              marginBottom: 1,
            }}>
            <CustomText style={{style: {flexGrow: 1}}}></CustomText>
            <CustomText>{`-${detailContrat.primeTTC} Ar`}</CustomText>
          </View>
        </View>
      </View>
      <View style={{height: 50}}>
        <CustomText type="paragraph">
          Rien d’autre n’est changé aux Conditions tant Générales que
          Particulières de la police sus relatée.
        </CustomText>
        <CustomText type="paragraph">
          <CustomText>Fait à Antananarivo, le </CustomText>
          <CustomText type="bold">{detailContrat.dateEcriture}</CustomText>
        </CustomText>
      </View>
    </View>
  );
};
